import React, { Suspense, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from '../Sidebar';
import FloatingVoiceAssistant from '../FloatingVoiceAssistant';
import PageLoader from '../PageLoader';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedLayout = () => {
  const { user, isAuthenticated } = useAuth();

  const outletContext = useMemo(
    () => ({
      user,
    }),
    [user],
  );

  return (
    <>
      <div className="page-container">
        <Sidebar user={user} />
        <div className="main-content">
          <Suspense fallback={<PageLoader />}>
            <Outlet context={outletContext} />
          </Suspense>
        </div>
      </div>
      {isAuthenticated && user ? <FloatingVoiceAssistant user={user} /> : null}
    </>
  );
};

export default ProtectedLayout;

